<template>
  <div>
    <div class="recommendContent">
      <!--顶部信息-->
      <div class="topInfo">
        <div>
          <span>最新入驻</span>
          <span>(家纺全产业链商家皆可入驻)</span>
        </div>
        <div @click="goToMoreShop">
          <span style="color:#662D91">查看全部</span>
          <div class="more">
            <img src="../assets/images/images/next.png" />
          </div>
        </div>
      </div>
      <!--列表信息-->
      <div class="listInfo" id="parent" @touchstart="touchList">
        <div
          v-for="(item,index) in shopList"
          class="shopInfo"
          :key="index"
          @click="goShopInfo(item.shop_id)"
        >
          <div class="shopHead">
            <img :src="item.shop.logo_url" />
          </div>
          <div class="shopName">
            <span>{{item.shop.name}}</span>
          </div>
        </div>
        <!--更多商家-->
        <div class="moreShop">
          <div @click="goMyShop">申请入驻</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
let me;
let time;
import { Dialog  } from "vant";
import { getData } from "../Interface/http.js";
export default {
  data() {
    return {
      shopList: [], //店铺列表
      loginStatus: false, //是否已经登录
    };
  },
  props: ['vipStatus','leftDay'],
  methods: {
    touchList() {
      clearInterval(time);
    },
    goShopInfo(id) {
      me.$router.push({
        name: "shopDetailInfo",
        query: {
          type: "info",
          id: id,
        },
      });
    },
    getUserInfo(){
      getData("/user/info",{token:localStorage.getItem("token")!= ""?localStorage.getItem("token"):"123456"}).then(res=>{
              if(res.code==0){
                me.userInfoData=res.data;
              }
            }).catch(err=>{
              console.log(err);
            })
    },
    login() {
      getData("/oauth/redirect/wechat").then(res => {
        localStorage.setItem("startPage", "home");
        window.location.href = res.data.redirect_url;
      });
    },
    //跳转到续费页面
    goXFPage() {
      this.$router.push({
        name: "continuePay",
        query: {
          id: me.userInfoData.shop_id,
        },
      });
    },
    //判断跳转我的店铺还是申请店铺
    goMyShop(){
      let me=this;
      if(!me.loginStatus){//如果未登录
        //如果未登录
        me.login();
        return;
      }
      if (me.leftDay.type == "over") {
        Dialog.confirm({
          message: "你之前的门店已过期，是否续费",
        })
          .then(() => {
            me.goXFPage();
          })
          .catch(() => {
            console.log("取消");
          });
        return;
      }
      if (me.userInfoData.shop_id == 0 || !me.userInfoData.shop_status) {
        if (me.vipStatus && me.vipStatus.type == "on") {
            this.$toast("后台正在审核，请勿重新申请！");
            return;
        }
        this.$router.push({
          name: "addShop",
        });
      }else{
        Dialog.confirm({
          message: '您已开通过店铺，是否进入自己的店铺管理中心',
        })
          .then(() => {
            me.$router.push({
              name: "mangerMyShop",
              query: {
                shop_id: me.userInfoData.shop_id,
              },
            });
          })
          .catch(() => {
            console.log("取消");
          });
      }
     
    },
    /**
            跳转到商家列表页面
         */
    goToMoreShop() {
      me.$router.push({
        name: "shopList",
      });
    },
    /**
            获取推荐商家列表
         */
    getListData() {
      getData("/recommend-shops", {}).then((res) => {
        if (res.code == 0) {
          //接口调用成功
          me.shopList = res.data;
        }
      });
    },
  },
  mounted() {
    me = this;
    me.getListData();
    me.getUserInfo();
    me.$nextTick(() => {
      var div2 = document.getElementById("parent");
      if(div2) {
        time = setInterval(function () {
          div2.scrollLeft++;
        }, 17);
      }
    });
    window.addEventListener("scroll", function () {
      clearInterval(time);
    });
    if (
      localStorage.getItem("token") == null ||
      localStorage.getItem("token") == "123456"
    ) {
      this.loginStatus = false;
    } else {
      this.loginStatus = true;
    }
  },
};
</script>
<style scoped>
.recommendContent {
  width: 95%;
  height: 102px;
  margin: 10px auto;
  background-color: white;
  border-radius: 6px;
}
.topInfo {
  padding-top: 5px;
  display: flex;
}
.topInfo > div {
  flex-grow: 1;
}
.topInfo div:nth-child(1) {
  margin-left: 8px;
  display: flex;
  justify-content: flex-start;
  font-size: 14px;
  color: #666666;
}
.topInfo div:nth-child(1) span:nth-child(2) {
  font-size: 10px;
  display: flex;
  align-items: center;
  margin-left: 5px;
  color: #dcdcdc;
}
.topInfo > div:nth-child(2) {
  display: flex;
  justify-content: flex-end;
  margin-right: 8px;
  font-size: 14px;
  color: #666666;
  align-items: center;
}
.more {
  width: 13px;
  height: 15px;
}
.more img {
  width: 100%;
  height: 100%;
}

.listInfo {
  width: 100%;
  overflow-x: scroll;
  display: flex;
  justify-content: flex-start;
  margin-top: 5px;
}
.shopInfo {
  display: flex;
  flex-direction: column;
  text-align: center;
  margin-left: 10px;
  margin-right: 5px;
}
.moreShop {
  width: 55px;
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  color: #8f8f8f;
}
.moreShop div {
  width: 55px;
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.shopHead {
  width: 50px;
  height: 50px;
  display: inline-block;
}
.shopHead img {
  width: 100%;
  height: 100%;
}
.shopName {
  width: 50px;
  color: #666666;
  text-align: center;
  font-size: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>